console.log('[App Init] main.ts executing at:', new Date().toISOString());

import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import Vuetify, { colors, VSelect } from 'vuetify/lib';
import VuetifyConfirm from 'vuetify-confirm';
//import VueCropper from 'vue-cropperjs';
import LoggedOutLayout from '@/layouts/LoggedOutLayout.vue';
import LoggedInLayout from '@/layouts/LoggedInLayout.vue';
import LoggedInNonScrollyLayout from '@/layouts/LoggedInNonScrollyLayout.vue';
import AnonLayout from '@/layouts/AnonLayout.vue';
import BlankLayout from '@/layouts/BlankLayout.vue';
import KBLayout from '@/layouts/KBLayout.vue';
import FullDateFilter from '@/filters/FullDate';
import FullDateTimeFilter from '@/filters/FullDateTime';
import ShortDateFilter from '@/filters/ShortDate';
import DayShortMonthFilter from '@/filters/DayShortMonth';
import NumberFilter from '@/filters/Number';
import JobWorkerNotInterestedReasonFilter from '@/filters/JobWorkerNotInterestedReason';
import InterviewWorkerDeclinedReasonFilter from '@/filters/InterviewWorkerDeclinedReason';
import InterviewContactDeclinedReasonFilter from '@/filters/InterviewContactDeclinedReason';
import FullAddressFilter from '@/filters/FullAddress';
import ShiftTimeFilter from '@/filters/ShiftTime';
import ShiftHoursFilter from '@/filters/ShiftHours';
import TimeFilter from '@/filters/Time';
import TimeAgoFilter from '@/filters/TimeAgo';
import StatusFilter from '@/filters/Status';
import EmailTemplateTypeFilter from '@/filters/EmailTemplateType';
import ConversationTopicTypeFilter from '@/filters/ConversationTopicType';
import CurrencyFilter from '@/filters/Currency';
import CurrencyShortFilter from '@/filters/CurrencyShort';
import PhoneNumberFilter from '@/filters/PhoneNumber';
import InterviewTypeFilter from '@/filters/InterviewType';
import InterviewTypeIconFilter from '@/filters/InterviewTypeIcon';
import InPersonInterviewAddressTypeFilter from '@/filters/InPersonInterviewAddressType';
import InterviewCancelledReasonFilter from '@/filters/InterviewCancelledReason';
import OfferCancelledReasonFilter from '@/filters/OfferCancelledReason';
import OfferWorkerDeclinedReasonFilter from '@/filters/OfferWorkerDeclinedReason';
import OfferContactDeclinedReasonFilter from '@/filters/OfferContactDeclinedReason';
import GenderFilter from '@/filters/Gender';
import AgencyBrandThemeModeFilter from '@/filters/AgencyBrandThemeMode';
import MaritalStatusFilter from '@/filters/MaritalStatus';
import LocationWorkerTypeFilter from '@/filters/LocationWorkerType';
import AvailabilityRestrictionFilter from '@/filters/AvailabilityRestriction';
import DeclinedReasonFilter from '@/filters/DeclinedReason';
import FormTypeFilter from '@/filters/FormType';
import QuestionTypeFilter from '@/filters/QuestionType';
import NoteTypeFilter from '@/filters/NoteType';
import YesNoFilter from '@/filters/YesNo';
import OpenClosedFilter from '@/filters/OpenClosed';
import OnOffFilter from '@/filters/OnOff';
import JobStatusFilter from '@/filters/JobStatus';
import InterviewStatusFilter from '@/filters/InterviewStatus';
import JobClosedReasonFilter from '@/filters/JobClosedReason';
import IntegrationTypeFilter from '@/filters/IntegrationType';
import InvoiceTypeFilter from '@/filters/InvoiceType';
import AgentTaskTypeFilter from '@/filters/AgentTaskType';
import AgentTaskCategoryFilter from '@/filters/AgentTaskCategory';
import AgentModelProviderFilter from '@/filters/AgentModelProvider';
import AgenticTaskStatusFilter from '@/filters/AgenticTaskStatus';
import OpenEntityInNewWindowBtn from '@/components/Shared/OpenEntityInNewWindowBtn.vue'
import OpenEntityInCurrentWindowLink from '@/components/Shared/OpenEntityInCurrentWindowLink.vue'
import GoogleMapsDialog from '@/components/Shared/GoogleMapsDialog.vue';
// @ts-ignore
import VueChatScroll from 'vue-chat-scroll';
// @ts-ignore
import { initializeApp } from 'firebase/app';
import { getAuth } from "firebase/auth";
// @ts-ignore
import JsonViewer from 'vue-json-viewer';

//Can't find Typescript def for v-currency-field 
// @ts-ignore
import VCurrencyField from 'v-currency-field';
import { VTextField } from 'vuetify/lib'
//Can't find Typescript def for vuetify-google-autocomplete but a potential solution here:
//https://github.com/MadimetjaShika/vuetify-google-autocomplete/issues/53
//  @ts-ignore
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
//Can't find Typescript def for vuetify-google-autocomplete but a potential solution here:
// @ts-ignore
import * as VueGoogleMaps from 'vue2-google-maps';
// @ts-ignore
//import { TimeAgo } from 'vue2-timeago';
////import 'vue2-timeago/dist/vue2-timeago.css';

// Vue.use(VuetifyGoogleAutocomplete, {
//   apiKey: 'AIzaSyAF_AYTsAdkQVn5O3Dfz-Y2xDx3Bq-NUmw', // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
//   //version: '...', // Optional
//   //language: '...', // Optional
//   installComponents: true, // Optional (default: true) - false, if you want to locally install components
//   vueGoogleMapsCompatibility: false, // Optional (default: false) - true, requires vue2-google-maps to be configured see https://github.com/xkjyeah/vue-google-maps
// });

import Editor from '@tinymce/tinymce-vue';

import MaritalStatus from './models/Shared/MaritalStatus';
import AppConsts from './lib/appConstants';
import { sanitizeHtml } from './lib/sanitizeHtml';
// @ts-ignore
import VuetifyTimeSelect from 'vuetify-time-select'
import { AppModule } from './store/modules/app';

Vue.component('vuetify-time-select', VuetifyTimeSelect)

// XSS-safe replacement for v-html: sanitizes the bound HTML with DOMPurify
// before it is written to the DOM. Use `v-safe-html` anywhere raw HTML must
// be rendered from tenant/user-supplied content.
Vue.directive('safe-html', {
  inserted(el, binding) {
    el.innerHTML = sanitizeHtml(binding.value);
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      el.innerHTML = sanitizeHtml(binding.value);
    }
  },
});


Vue.use(VueGoogleMaps, {
  load: {
      key: process.env.VUE_APP_MAPS_API_KEY,
      // This is required to use the Autocomplete plugin
      libraries: 'places', // 'places,drawing,visualization'
      loading: 'async',
  },
});

Vue.use(VuetifyGoogleAutocomplete, {
  /*
    not used as loaded with component
    apiKey: key,
  */
  vueGoogleMapsCompatibility: true,
});

//Vue.component(VueCropper);
Vue.use(VueChatScroll);

Vue.use(JsonViewer);

Vue.component('tinymce', Editor);
//Vue.component('time-ago', TimeAgo);
Vue.component('anon-layout', AnonLayout);
Vue.component('blank-layout', BlankLayout);
Vue.component('logged-in-layout', LoggedInLayout);
Vue.component('logged-in-non-scrolly-layout', LoggedInNonScrollyLayout);
Vue.component('logged-out-layout', LoggedOutLayout);
Vue.component('kb-layout', KBLayout);
Vue.component('open-entity-in-new-window-btn', OpenEntityInNewWindowBtn);
Vue.component('open-entity-in-current-window-link', OpenEntityInCurrentWindowLink);
Vue.component('google-maps-dialog-btn', GoogleMapsDialog);

//Register global filters
Vue.filter('FullDate', FullDateFilter );
Vue.filter('FullDateTime', FullDateTimeFilter );
Vue.filter('ShortDate', ShortDateFilter );
Vue.filter('DayShortMonth', DayShortMonthFilter );
Vue.filter('Number', NumberFilter );
Vue.filter('FullAddress', FullAddressFilter ); 
Vue.filter('ShiftTime', ShiftTimeFilter ); 
Vue.filter('ShiftHours', ShiftHoursFilter );
Vue.filter('Time', TimeFilter );
Vue.filter('TimeAgo', TimeAgoFilter );
Vue.filter('Status', StatusFilter );
Vue.filter('Currency', CurrencyFilter);
Vue.filter('CurrencyShort', CurrencyShortFilter);
Vue.filter('PhoneNumber', PhoneNumberFilter);
Vue.filter('Gender', GenderFilter);
Vue.filter('MaritalStatus', MaritalStatusFilter);
Vue.filter('AvailabilityRestriction', AvailabilityRestrictionFilter);
Vue.filter('DeclinedReason', DeclinedReasonFilter);
Vue.filter('YesNo', YesNoFilter);
Vue.filter('OpenClosed', OpenClosedFilter);
Vue.filter('OnOff', OnOffFilter);
Vue.filter('LocationWorkerType', LocationWorkerTypeFilter);
Vue.filter('ConversationTopicType', ConversationTopicTypeFilter);
Vue.filter('FormType', FormTypeFilter);
Vue.filter('QuestionType', QuestionTypeFilter);
Vue.filter('EmailTemplateType', EmailTemplateTypeFilter );
Vue.filter('JobWorkerNotInterestedReason', JobWorkerNotInterestedReasonFilter);
Vue.filter('JobStatus', JobStatusFilter);
Vue.filter('InterviewStatus', InterviewStatusFilter);
Vue.filter('JobClosedReason', JobClosedReasonFilter);
Vue.filter('InterviewType', InterviewTypeFilter);
Vue.filter('InterviewTypeIcon', InterviewTypeIconFilter);
Vue.filter('InterviewWorkerDeclinedReason', InterviewWorkerDeclinedReasonFilter);
Vue.filter('InterviewContactDeclinedReason', InterviewContactDeclinedReasonFilter);
Vue.filter('InPersonInterviewAddressType', InPersonInterviewAddressTypeFilter);
Vue.filter('InterviewCancelledReason', InterviewCancelledReasonFilter);
Vue.filter('OfferCancelledReason', OfferCancelledReasonFilter);
Vue.filter('OfferContactDeclinedReason', OfferContactDeclinedReasonFilter);
Vue.filter('OfferWorkerDeclinedReason', OfferWorkerDeclinedReasonFilter);
Vue.filter('BrandThemeMode', AgencyBrandThemeModeFilter);
Vue.filter('IntegrationType', IntegrationTypeFilter);
Vue.filter('NoteType', NoteTypeFilter);
Vue.filter('InvoiceType', InvoiceTypeFilter);
Vue.filter('AgentTaskType', AgentTaskTypeFilter);
Vue.filter('AgentTaskCategory', AgentTaskCategoryFilter);
Vue.filter('AgentModelProvider', AgentModelProviderFilter);
Vue.filter('AgenticTaskStatus', AgenticTaskStatusFilter);

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: AppConsts.brand.primaryColor,
        secondary: AppConsts.brand.secondaryColor
      },
    },
  },
})
Vue.config.productionTip = false;

Vue.use(Vuetify, {
  components: {
    VTextField, VSelect
  }
});
Vue.use(VuetifyConfirm, {
  vuetify
});

Vue.use(VCurrencyField, { 
  locale: 'en-GB',
  prefix: "£",
	decimalLength: 2,
	autoDecimalMode: true,
	min: null,
	max: null,
	defaultValue: 0,
  valueAsInteger: true,
  allowNegative: false
})

console.log('[App Init] Setting up Firebase auth listener at:', new Date().toISOString());

let app: Vue | null = null;

// We create the Vue object inside a firebase auth state changed event because
// otherwise Vue is created before we have the user context...
getAuth().onAuthStateChanged(user => {
  console.log('[Firebase Auth] onAuthStateChanged fired at:', new Date().toISOString());
  AppModule.setCurrentUser(user);
  if (!app) {
    console.log('[Firebase Auth] Creating Vue app at:', new Date().toISOString());
    app = new Vue({
      store,
      router,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }
})
console.log('[App Init] Finished setting up Firebase auth listener at:', new Date().toISOString());

